var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page padded dashboard"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"title"},[_vm._v(" Dashboard ")]),_c('ActiveReservations'),_c('TopContent')],1),_c('div',{staticClass:"right"},[_c('ReservationsChart')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }